/** Fi concierge scope line shown in the welcome hero. */
export const FI_SCOPE_LINE =
  'Your concierge for stories, peer listeners, and organizational resources — tell me what you need and I’ll point you in the right direction.';

export const FI_ABOUT_INTRO =
  'Fi is Kindly Human’s concierge — not a clinician or crisis line. I help you explore what’s available and connect you to the right next step.';

export const FI_ABOUT_EXPECTATIONS = [
  'Ask in your own words — I’ll search stories, listeners, Peersonas, and resources based on what you share.',
  'When I find a match, results appear right here in the chat so you can browse without losing the thread.',
  'Organizational resources update as we talk — open the resources drawer anytime from the strip above your messages.',
  'Conversations stay between you and Fi unless you choose to connect with a peer listener.',
] as const;
